import { reactLocalStorage } from "reactjs-localstorage";
import apiClient from "./middleware";

/**
 * Authenticate user via middleware.
 *
 * @prop object user    User object with username and password keys.
 *
 * @return void
 */
export const loginUser = async ({ username, password }) => {
	const authToken = reactLocalStorage.get("authToken", false);
	const apiResponseInfo = reactLocalStorage.getObject("authInfo");

	if (
		Object.keys(apiResponseInfo).length &&
		authToken
	) {
		let user = reactLocalStorage.getObject("user");
		return postAuthAction(user);
	} else {
		// Authenticate with username/password via Middleware
		const apiAuthenticateResponse = await apiClient.authenticate(
			username.trim(),
			password
		);

		if (apiAuthenticateResponse) {
			return postAuthAction(apiAuthenticateResponse);
		} 
		return apiAuthenticateResponse;
	}
};

export const getClubs = async () => {
	const clubs = await apiClient.pullClubs();
	return clubs;
}

export const getResources = async (clubId) => {
	const resources = await apiClient.pullResources(clubId);
	return resources;
}

export const getAttendance = async(spooftime) => {
	const classes = await apiClient.pullAttendance(1,spooftime);
	return classes;
}

export const markAttended = async(memberId, classId, classDate) => {
	const checkinResponse = await apiClient.markAttended(memberId, classId, classDate);
	return checkinResponse;
}

/**
 * Post auth actions.
 *
 * @param string username     Username.
 * @param string password     Password.
 * @param object user         User object.
 */
const postAuthAction = function(user) {
	reactLocalStorage.setObject("user", user);
	return "authenticated";
};



// WEBPACK FOOTER //
// ./src/actions/actions.js